import React from 'preact/compat';
import { h } from 'preact';
import Modal, { ModalProps } from '@ingka/modal';
import { PREFIX } from 'list/DesignSystem/constants';
import './modalWrapper.scss';

const ModalWrapper = (props: ModalProps) => (
    <Modal prefix={PREFIX} {...props}>
        {props.children}
    </Modal>
);

export default ModalWrapper;
